import { Dispatch, SetStateAction, createContext, useContext } from 'react';

interface AccordianContextData {
    isExpanded: boolean;
    setIsExpanded: Dispatch<SetStateAction<boolean>>;
}

/************************************* Context **********************************************/

export const AccordianContext = createContext<AccordianContextData>(null);

/************************************* Hooks **********************************************/

export const useAccordianContext = () => {
    const context = useContext(AccordianContext);

    if (context == null) {
        throw new Error('Accordian components must be wrapped in <Accordian />');
    }

    return context;
};
